import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { SnIconModule } from '@lib/ui/icon';

import { HeaderComponent } from './components/header';
import { LanguageSelectorComponent } from './components/language-selector';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, SnIconModule],
  declarations: [HeaderComponent, LanguageSelectorComponent],
  exports: [HeaderComponent, LanguageSelectorComponent],
})
export class SharedModule {}

